import axios from 'axios'
import { Toast } from 'cube-ui'
import Cookies from 'js-cookie'

// create an axios instance
const service = axios.create({
  // baseURL: '/api', // process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

var loadding
// request interceptor
service.interceptors.request.use(
  config => {
    if (!loadding) {
      loadding = Toast.$create({
        txt: '加载中...',
        time: 33000,
        mask: true
      })
    }
    loadding.show()
    let token = Cookies.get('token')
    if (token) config.headers['X-Token'] = token
    return config
  },
  error => {
    if (loadding) loadding.hide()
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (loadding) loadding.hide()
    console.log('网络请求返回数据', res)
    return res
  },
  error => {
    console.log('err' + error) // for debug
    if (loadding) loadding.hide()
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js